import { aTrack } from '../primitives/a-track';
import { getDepositSlippage } from '../slippage';
class FailureEvents {
    constructor() {
        this.options = {
            origin: 'failure',
        };
    }
    deposit_failure(step, reason, pool, tokens, deposit_tab, mode, bring_in, amounts_in, expected_minted_shares, dollar_value, hash) {
        aTrack('deposit_failure', Object.assign({ step,
            reason,
            pool,
            tokens,
            deposit_tab,
            mode,
            bring_in,
            amounts_in,
            expected_minted_shares,
            dollar_value, slippage: getDepositSlippage(), hash }, this.options));
    }
    withdraw_failure(step, reason, pool, tokens, percentage, amounts_out, expected_burnt, dollar_value, hash) {
        aTrack('withdraw_failure', Object.assign({ step,
            reason,
            pool,
            tokens,
            percentage,
            amounts_out,
            expected_burnt,
            dollar_value,
            hash }, this.options));
    }
    trade_failure(step, reason, token_in, token_out, amount_in, expected_out, minimum_out, slippage, dollar_value, hash) {
        aTrack('trade_failure', Object.assign({ step,
            reason,
            token_in,
            token_out,
            amount_in,
            expected_out,
            minimum_out,
            slippage,
            dollar_value,
            hash }, this.options));
    }
}
export function createFailureEvent() {
    return new FailureEvents();
}
//# sourceMappingURL=failure-event.js.map